export default "__VITE_ASSET__BzVKeOaL__"